import {PayAction} from './PayAction';

export interface PayActionMap {
    [pay: number]: PayAction;
}
